import React from 'react'
import { ALL_NEWS, NEWS } from 'utils/queries'
import { initializeApollo } from 'gql/client'
import { gql } from '@apollo/client'
import ArticoloTemplate from 'components/templates/ArticoloTemplate/ArticoloTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

function BlogDetail({ news, pagina }) {
  return <ArticoloTemplate articolo={news} pagina={pagina} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []
  const maxPathsNumber = 10
  for (const locale of locales) {
    const client = initializeApollo(null, null, null, locale)
    const {
      data: { allNews },
    } = await client.query({
      query: gql`
        ${ALL_NEWS}
      `,
    })
    let numberAdded = 0
    allNews?.edges.forEach((x) => {
      if (numberAdded < maxPathsNumber) {
        paths.push({ params: { slug: x.node.slug }, locale: locale })
        numberAdded += 1
      } else return
    })
  }

  return {
    paths,
    fallback: 'blocking',
  }
}, '/blog/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, locale, preview, previewData }) => {
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}
    const client = initializeApollo(null, null, null, locale)

    try {
      const {
        data: { news },
      } = await client.query({
        query: gql`
          ${NEWS.replace('__slug__', slug)}
        `,
        context: {
          headers,
        },
      })

      if (!news) {
        return {
          notFound: true,
        }
      }

      return {
        props: { news, pagina: news.pagina, key: news.pk },
        revalidate: 60 * 10,
      }
    } catch {
      return {
        props: {},
        revalidate: 60 * 10,
      }
    }
  }
)

export default BlogDetail
